import loader from '../moduleLoader.js';
import Icon from '../../helpers/iconHelper.js';

class Map {
  constructor(container) {
    this.container = container;
    this.map = null;
    this.infobox = null;
    this.markers = [];
    this.cluster = null;
    this.loaded = false;
    this.defaultCenter = { lat: 62.9, lng: 15.6 };
    this.defaultZoom = 5;
    this.types = [];
    this.typeIcon = [
      { default: "default" },
      { store: "store" },
      { premise: "premise" },
      { property: "property" },
      { buildingright: "buildingright" },
      { area: "area" },
      { artwork: "artwork" },
      { garage: "garage" },
      { visitorparking: "visitorparking" },
    ];

    this.infoBoxSettings = {
      disableAutoPan: false,
      maxWidth: 510,
      pixelOffset: new google.maps.Size(-255, -28),
      zIndex: null,
      boxClass: "infobox-extended",
      boxStyle: { width: "510px" },
      closeBoxURL: "/areas/public/images/cross-gray.svg",
      infoBoxClearance: new google.maps.Size(30, 30),
      alignBottom: true
    };
    this.infoBoxSettingsMobile = {
      disableAutoPan: false,
      maxWidth: 330,
      pixelOffset: new google.maps.Size(-165, -28),
      zIndex: null,
      boxClass: "infobox-extended infobox-extended--mobile",
      boxStyle: { width: "330px" },
      closeBoxURL: "/areas/public/images/cross-gray.svg",
      infoBoxClearance: new google.maps.Size(30, 30),
      alignBottom: true
    }
    this.infoBoxSettingsSimple = {
      disableAutoPan: false,
      maxWidth: 150,
      pixelOffset: new google.maps.Size(-120, -50),
      zIndex: null,
      boxStyle: { width: "240px" },
      closeBoxURL: "/areas/public/images/cross-gray.svg",
      infoBoxClearance: new google.maps.Size(10, 10),
      alignBottom: true
    }

    this.toggleFilter = this.toggleFilter.bind(this);
    this.toggleMarkersOfType = this.toggleMarkersOfType.bind(this);
  }

  init() {
    const json = this.container.dataset.markers ? JSON.parse(this.container.dataset.markers) : [];
    const mapContainer = this.container.getElementsByClassName('map-container')[0];

    this.map = new google.maps.Map(mapContainer, {
      zoom: 5,
      scrollwheel: false,
      mapTypeControl: false,
      fullscreenControl: false
      });

    this.infobox = new InfoBox();
    this.infobox.setOptions(this.getInfoBoxSetting());

    var infobox = this.infobox;

    var bounds;
    if(json.length > 0) {
        bounds = this.setMarkers(this.map, json);
        this.map.fitBounds(bounds);
    }
    else {
      this.map.setCenter(this.defaultCenter);
    }

    var listener = google.maps.event.addListener(this.map, "idle", function () {
      if (this.loaded === false && this.container.offsetWidth > 0) {
        this.loaded = true;
        if (bounds && this.cluster) {
          this.map.fitBounds(bounds);
          setTimeout(() => {
            this.cluster.repaint();
          }, 100);
        }
      }
      if (this.map.zoom > 20) {
        this.map.setZoom(15);
      }
    }.bind(this));
    var clickListener = google.maps.event.addListener(this.map, "click", function(event) {
      infobox.close();
    });

    this.setTypes();

    if (this.hasFilters()) {
      const markerLabels = this.container.dataset.markerLabels ? JSON.parse(this.container.dataset.markerLabels) : [];
      var toggleFilterButton = this.container.getElementsByClassName('map-filter__toggle')[0];
      var filterContainer = this.container.getElementsByClassName('map-filter')[0];
      var closeFilterButton = this.container.getElementsByClassName('map-filter__close-filter')[0];
      filterContainer.classList.add('map-filter--visible');

      toggleFilterButton.addEventListener('click', this.toggleFilter);
      closeFilterButton.addEventListener('click', this.toggleFilter);

      var filterClickListener = filterContainer.addEventListener("click", function(event) {
        infobox.close();
      });

      // Temp fix for slow marker creation
      setTimeout(() => {
        this.bindFilterTypes(markerLabels);
      }, 500);
      this.hideUnusedFilter();
    }
  }

  getInfoBoxSetting() {
    var settings;
    if (this.container.className.indexOf('fullscreen') === -1 && this.container.className.indexOf('map--wide') === -1){
      return this.infoBoxSettingsSimple;
    } else if (document.body.clientWidth < 481) {
      settings = this.infoBoxSettingsMobile;
    } else {
      settings = this.infoBoxSettings;
    }
    if (this.container.className.indexOf('fullscreen') > -1) {
      settings.infoBoxClearance = new google.maps.Size(30, 150);
    }
    return settings;
  }

  hasFilters() {
    // Show filters if more than one type is present
    if (this.types.length > 1) {
      return true;
    } else {
      return false;
    }
  }

  hideUnusedFilter() {
    var allFilterElements = this.container.getElementsByClassName('map-filter__checkbox');
    var allFilterIds = [];
    for(var i = 0; i < allFilterElements.length; i++) {
      var filter = allFilterElements[i];
      allFilterIds.push(filter.children[1].getAttribute('id').substring(3));
    }
    var types = this.types;
    allFilterIds.filter(function(id) {
      return types.indexOf(id) === -1;
    }).map(function(id){
      document.getElementById('id-'+id).parentElement.classList.add('map-filter__checkbox--hidden');
      return id;
    })
  }

  update(json) {
    this.removeMarkers();
    if(json.length > 0) {
      const bounds = this.setMarkers(map, json);
      this.map.fitBounds(bounds);
    }
    else {
      this.map.setCenter(this.defaultCenter);
      this.map.setZoom(this.defaultZoom);
    }
  }

  setMarkers(map, json) {
    var bounds = new google.maps.LatLngBounds();
    json.forEach((entry) => {
        var markerPosition = this.getMarkerPosition(entry);
        var icon = {
            url: '/areas/public/images/' + entry.Type + 'mapsmarkerv2.svg',
            size: new google.maps.Size(48, 56),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(13, 38),
            scaledSize: new google.maps.Size(48, 56)
        }

        var marker = new google.maps.Marker({
          position: markerPosition,
          type: entry.Type,
          map: map,
          icon,
        });

      this.markers.push(marker);
      var that = this;
      marker.addListener('click', function() {
        if (that.container.className.indexOf('map--smaller') > -1){
          // Do not show infobox
        } else if (that.container.className.indexOf('map--fullscreen') > -1 ||that.container.className.indexOf('map--wide') > -1){
          that.infobox.setContent(that.setLargeInfoboxContent(entry));
          that.infobox.open(map, this);
        } else {
          that.infobox.setContent(that.setInfoboxContent(entry.Title, entry.Link, entry.SmallTitle, entry.HtmlBody));
          that.infobox.open(map, this);
        }
      });

      bounds.extend(marker.position);
    });
    this.createClusters();
    return bounds;
  }

  getMarkerPosition(entry) {
    var latlng = new google.maps.LatLng(entry.Latitude, entry.Longitude);
    var finalLatLng = latlng;

    //check to see if any of the existing markers match the latlng of the new marker
    if (this.markers.length !== 0) {
        for (var i = 0; i < this.markers.length; i++) {
            var marker = this.markers[i];
            var pos = marker.getPosition();

            //if a marker already exists in the same position as this marker
            if (latlng.equals(pos)) {
                //update the position of the coincident marker by applying a small multipler to its coordinates
                var newLat = latlng.lat() + (Math.random() - .5) / 1500;// * (Math.random() * (max - min) + min);
                var newLng = latlng.lng() + (Math.random() - .5) / 1500;// * (Math.random() * (max - min) + min);
                finalLatLng = new google.maps.LatLng(newLat, newLng);
            }
        }
    }
    return finalLatLng;
  }

  hideMarkersOfType(type) {
    for (var i = 0; i < this.markers.length; i++) {
      var marker = this.markers[i];
      if (marker.type === type) {
        this.cluster.removeMarker(marker);
      }
    }
  }

  showMarkersOfType(type) {
    for (var i = 0; i < this.markers.length; i++) {
      var marker = this.markers[i];
      if (marker.type === type) {
        this.cluster.addMarker(marker);
      }
    }
  }

  toggleMarkersOfType(e) {
    var type = e.target.value;
    var checked = e.target.checked;

    if (checked) {
      this.showMarkersOfType(type);
    } else {
      this.hideMarkersOfType(type);
    }

    this.centerMapBounds(this.cluster.getMarkers());
  }

  centerMapBounds(markers) {
    var bounds = new google.maps.LatLngBounds();
    if (markers.length > 0) {
      markers.forEach((marker) => {
        bounds.extend(marker.position);
      });
      this.map.fitBounds(bounds);
    } else {
      this.map.setCenter(this.defaultCenter);
      this.map.setZoom(this.defaultZoom);
    }
  }

  setTypes() {
    for (var i = 0; i < this.markers.length; i++) {
      var marker = this.markers[i];
      if (this.types.includes(marker.type)) {
        continue;
      } else {
        this.types.push(marker.type);
      }
    }
  }

  bindFilterTypes(markerLabels) {
    for (var i = 0; i < this.types.length; i++) {
      var type = this.types[i];
      var id = 'id-'+type;
      var labelElement = document.getElementById(id);
      if (labelElement) {
        labelElement.addEventListener('change', this.toggleMarkersOfType);
      }
    }
  }

  toggleFilter(e) {
    e.stopPropagation();
    this.infobox.close();
    var filterContainer = this.container;
    if (filterContainer.className.indexOf('visible') > -1) {
      filterContainer.classList.remove('filters-default-visible');
      filterContainer.classList.remove('filters-visible');
      document.body.classList.remove('map-filters-visible');
    } else {
      filterContainer.classList.remove('filters-default-visible');
      filterContainer.classList.add('filters-visible');
      document.body.classList.add('map-filters-visible');
    }
  }

  createClusters() {
    var clusterOptions = {
      gridSize: 37,
      styles: [
        {
          url: "/areas/public/images/clustermapsmarkerv2.svg",
          width: 48,
          height: 56,
          anchorText: [-5, 0],
          textSize: 14,
          textColor: "#fff",
        },
      ],
      zoomOnClick: true,
      averageCenter: true,
    };
    this.cluster = new MarkerClusterer(this.map, this.markers,clusterOptions);
  }

  removeMarkers(){
    for(var i = 0; i < this.markers.length; i++){
        this.markers[i].setMap(null);
    }
    this.markers = [];
    if(this.cluster) {
      this.cluster.clearMarkers();
    }
  }

  setInfoboxContent(title, link, smallTitle, text) {
    return `
      <div class="infobox">
        <strong class="infobox__title${smallTitle ? ' infobox__title--small' : ''}">
          ${link ? `<a href="${link}">${title}</a>` : title}
        </strong>
        <div class="infobox__body">
          ${text ? text : ''}
        </div>
      </div>
    `;
  }

  setLargeInfoboxContent(content) {
    var icon = new Icon('chevron');
    var iconHtml = icon.render();

    return `
      <div class="infobox-extended__container">
        <div class="infobox-extended__container__image">
          <img src="${content.ImageUrl}" />
          <strong class="infobox-extended__container__title">${content.Title}</strong>
        </div>
        <div class="infobox-extended__container__info">
          <p class="infobox-extended__container__text">
            ${content.HtmlBody}
          </p>
          <a href="${content.Link}" class="btn">
            ${iconHtml}
            ${content.LinkText}</a>
        </div>
      </div>
    `;
  }
}

loader.add('Map', Map);

export default Map;
